var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-prim-grad-1 fw-bolder point underlined",on:{"click":_vm.download}},[_vm._v("Stampa informativa")])}
var staticRenderFns = []

export { render, staticRenderFns }